import { borderColor, borderRadius, borderWidth, marginSize, paddingSize } from '../../Utilities/utils/Theming';

export const snackbarBaseStyles = {
	display: 'inline-flex',
	maxWidth: '100%',
};

export const snackbarBaseStylesInline = {
	display: 'block',
	width: '100%',
};

export const snackbarColor = (
	kind: 'info' | 'positive' | 'warning' | 'negative' | 'phantom' | undefined,
	phantom: boolean,
	$theme: any,
) => {
	if (phantom) {
		return {
			backgroundColor: $theme.colors.toastPhantomBackground,
			...borderColor($theme.feedback.borderColorPhantom),
		};
	}

	if (kind === 'positive') {
		return {
			backgroundColor: $theme.colors.toastPositiveBackground,
			...borderColor($theme.feedback.borderColorPositive),
		};
	} else if (kind === 'warning') {
		return {
			backgroundColor: $theme.colors.toastWarningBackground,
			...borderColor($theme.feedback.borderColorWarning),
		};
	} else if (kind === 'negative') {
		return {
			backgroundColor: $theme.colors.toastNegativeBackground,
			...borderColor($theme.feedback.borderColorNegative),
		};
	} else {
		return {
			backgroundColor: $theme.colors.toastInfoBackground,
			...borderColor($theme.feedback.borderColorInfo),
		};
	}
};

export const snackbarBaseStyle = (
	kind: 'info' | 'positive' | 'warning' | 'negative' | undefined,
	phantom: boolean,
	$theme: any,
	displayBlock: boolean,
) => {
	return {
		maxWidth: '100%',
		height: 'auto',
		flex: '1',
		...borderRadius('var(--epods--border-radius)'),
		...borderWidth('var(--epods--border-width)'),
		borderStyle: 'solid',

		boxShadow: displayBlock ? 'none' : 'var(--epods--box-shadow-forth-bottom)',
		alignItems: 'center',
		fontFamily: 'var(--epods--font-base)',
		fontSize: 'var(--epods--feedback-text-font-size)',
		lineHeight: 'var(--epods--feedback-static-text-line-height)',
		verticalAlign: 'center',
		zIndex: 'var(--epods--zindex-feedback)' as any,
		...marginSize('0', '0', '0', '0'),
		...paddingSize(
			$theme.feedback.feedbackBodyPaddingTopBottom,
			$theme.feedback.feedbackBodyPaddingRightLeft,
			$theme.feedback.feedbackBodyPaddingTopBottom,
			$theme.feedback.feedbackBodyPaddingRightLeft,
		),
		...snackbarColor(kind, phantom, $theme),
	};
};

export const snackbarTitleStyle = {
	fontFamily: 'var(--epods--font-base-semibold)',
	fontSize: 'var(--epods--feedback-text-font-size)',
	color: 'var(--epods--color-text-primary)',
	marginRight: 'var(--epods--feedback-title-margin)',
	lineHeight: 'var(--epods--feedback-static-text-line-height)',
};

export const snackbarIconStyle = {
	flexShrink: 0,
	marginRight: '10px',
	color: 'var(--epods--color-text-primary)',
	display: 'flex',
	alighItems: 'center',
};

export const staticBodyContentStyle = {
	flexShrink: 0,
	color: 'var(--epods--color-text-primary)',
};

export const fluidBodyContentStyle = {
	flex: 1,
	fontFamily: 'var(--epods--font-base)',
	fontSize: 'var(--epods--feedback-text-font-size)',
	color: 'var(--epods--color-text-primary)',
	lineHeight: 'var(--epods--feedback-text-line-height)',
	overflow: 'hidden',
};

export const fluidBodyStyle = {
	overflow: 'hidden',
	textOverflow: 'ellipsis',
	whiteSpace: 'nowrap' as const,
	color: 'var(--epods--color-text-primary)',
};

export const snackbarBodyStyle = {
	display: 'flex',
	alignItems: 'center',
	color: 'var(--epods--color-text-primary)',
};

export const snackbarLinkStyle = {
	color: 'var(--epods--color-signal-info-icon)',
	paddingLeft: 'var(--epods--feedback-link-padding)',
	paddingRight: 'var(--epods--feedback-link-padding)',
	fontSize: 'var(--epods--feedback-text-font-size)',
	flexShrink: 0,
};
